import { styled } from 'utils/emotion';
import media from 'utils/mediaqueries';

export const SectionFormStyled = styled('section')({
  padding: '20px',

  [media('md')]: {
    padding: '70px 40px',
  },

  [media('lg')]: {
    padding: '100px 0',
  },
});

export const SectionFormWrapperStyled = styled('div')(
  {
    background: 'white',
    boxShadow: '0 10px 10px rgba(0,0,0,.15)',
    padding: '30px 25px 30px',

    [media('md')]: {
      padding: '80px 110px',
    },
  },
  ({ theme }) => ({
    borderRadius: theme.borderRadius,
  }),
);

export const HeadlineWrapperStyled = styled('div')({
  textAlign: 'center',
  marginBottom: '30px',

  [media('md')]: {
    textAlign: 'left',
    marginBottom: '40px',
  },

  [media('lg')]: {
    marginBottom: '60px',
  },
});

export const FormWrapperStyled = styled('div')({
  width: '100%',
  maxWidth: '600px',
  margin: '0 auto',

  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',

    [media('md')]: {
      gap: '24px',
    },
  },
});

export const GeneralMessageStyled = styled('div')(
  {
    padding: '16px 20px',
    borderRadius: '4px',
    fontSize: '14px',
    lineHeight: 1.4,
    margin: '20px 0',
  },
  ({ type }) => ({
    ...(type === 'success' && {
      backgroundColor: '#d4edda',
      color: '#155724',
      border: '1px solid #c3e6cb',
    }),
    ...(type === 'error' && {
      backgroundColor: '#f8d7da',
      color: '#721c24',
      border: '1px solid #f5c6cb',
    }),
  }),
); 